module.exports = __webpack_public_path__ + "media/images/salespartner/partner-figure02-37cea74888de1cd84135d96fbbaa6d55.svg";